/**
 * @author xiaohuangmao
 * @description 人员新增 | 编辑
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import moment from 'moment';
import Alert from './alert'
import FormTable from './formTable'
import { personDetailColumns } from './columns'
let { WizContainer, modelUtils, WizAvatarUpload } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool

class PersonDetail extends WizContainer {

  componentName = 'PersonDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let pageType = 'add'

    // 如果是编辑页面，则缓存来自列表页的这条记录，避免刷新页面之后字段被销毁。
    if (history.location && history.location.pathname === '/org/person/personDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('personDetailUpd', initialValue)
      } else {
        initialValue = Session.get('personDetailUpd') || {};
      }
      pageType = 'upd';
      this.getPersonAndUserIdentitiesInfo(initialValue.personId)
    }
    this.initialValue = initialValue;
    this.pageType = pageType;
  }

  // 根据人员id获取这行记录 修改的时候执行
  getPersonAndUserIdentitiesInfo = (personId) => {
    this.doActions([
      {
        path: 'personManage/getPersonAndUserIdentitiesInfoNew',
        payload: {
          key: 'personAndUserIdentitiesInfoKey',
          apiParams: { personId }
        }
      }
    ])
  }

  // 生命周期钩子函数 组件将要卸载时卸载清除sessionStorage
  // _componentWillUnmount(){
  //   Session.remove('personDetailUpd')
  // }

  // 生命周期钩子函数变体 对shouldComponentUpdate的封装
  propsAndStateOnChange = {
    add: this._add.bind(this),
    list: this._list.bind(this)
  }

  // 回调 人员记录
  _list(nextProps, nextState) {
    let list = nextProps['list'];
    if (list && list['success']) {
      let userIdentitys = list['data']['userIdentityInfoList'];
      const userIdentityInfoList = userIdentitys && userIdentitys.map(val => {
        return {
          personId: this.initialValue.personId,
          rowKey: val['id'],
          id: val['id'],
          orgId: val['orgId'],
          orgName: val['orgName'],
          positionId: val['positionId'],
          positionName: val['positionName'],
          positionBrandName: val['positionBrandName'],
          hireTime: val['hireTime'] ? moment(val['hireTime']).format('YYYY-MM-DD HH:mm') : undefined,
          updateTime: val['quitTime'] ? moment(val['quitTime']).format('YYYY-MM-DD HH:mm') : undefined,
          jobState: val['jobState']
        }
      });
      // 缓存下来 供formTable组件使用
      this.initialValue = {...list['data']['user'],...list['data']['personInfo']}
      this.initialValue.userIdentityCmdList = userIdentityInfoList
      return true
    } else {
      wizNotice.error(list && list['msg'] || '获取任职失败,请稍后尝试')
      return false
    }
  }

  _add(nextProps, nextState) {
    const { add } = nextProps
    if (add && add['success']) {
      wizNotice.success(add['msg'])
      this.jumpPage('replace', '/org/person');
      return true
    }
    wizNotice.error(add && add['msg'] || '操作失败,请稍后尝试')
    return false
  }

  /**
   * 格式化数据
   */
  formatValues = (values) => {
    const v = JSON.parse(JSON.stringify(values))
    const userIdentityCmdList = v.userIdentityCmdList
    //格式化时间
    userIdentityCmdList.forEach(val => {
      val.hireTime = moment(val['hireTime']).format('YYYY-MM-DD HH:mm:ss'),
        val.updateTime = val['updateTime'] ? moment(val['updateTime']).format('YYYY-MM-DD HH:mm:ss') : ''
      if (val.flag) { delete val.id; delete val.flag; }
    })
    if (v['picture'] && v['picture'].length) {
      v['avatar'] = v['picture'][0]['fileId'] ? v['picture'][0]['fileId'] : ''
    }
    return v
  }

  /**
   * 保存/更新 表单信息
   * @param values
   * @private
   */
  submitForm(values) {
    const formatValues = this.formatValues(values)
    this.doActions([
      {
        path: `personManage/${this.pageType}`,
        payload: {
          key: 'personManageKey',
          apiParams: { ...formatValues }
        },
        requireLoading: true
      }
    ])
  }

  _render() {
    const { personManageLoading } = this.props;
    const columns = personDetailColumns(this, [Alert, FormTable, WizAvatarUpload])

    const onSubmit = this.submitForm.bind(this);

    const formProps = {
      columns,
      onSubmit,
      record: null,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 15 }
      }
    }

    return (
      <React.Fragment>
        <WizCard>
          <WizSpin tip={"加载中"} spinning={personManageLoading}>
            <WizForm ref={(wizForm) => this._wizForm = wizForm} {...formProps} />
          </WizSpin>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { personManage } = state;
  const list = modelUtils.getModelEntity(personManage, "personAndUserIdentitiesInfoKey");
  const add = modelUtils.getModelEntity(personManage, "personManageKey");
  const load = modelUtils.getLoadingState(state, "personManage");
  return {
    list,
    add,
    ...load
  };
};

export default connect(mapStateToProps)(PersonDetail);
